import * as types from '../actions/action-types';

export function getUserProfileSuccess(userProfile) {
  return {
    type: types.GET_USER_PROFILE_SUCCESS,
    userProfile
  };
}

export function loginFailed(message, status) {
  return {
    type: types.LOGIN_FAILED,
    status,
    message
  };
}

export function loginSucceeded() {
  return {
    type: types.LOGIN_SUCCESS
  };
}

export function logoutSuccess() {
  return {
    type: types.LOGOUT_SUCCESS
  };
}
